import { Image } from './image.model';
import { Specification } from './specification.model';

export interface CurrentItem {
  make?: string;
  model?: string;
  colour?: string;
  short_description?: string;
  long_description?: string;
  purchase_price: number;
  appliance_category?: string;
  images?: Image[];
  summary_specs?: Specification[];
  compare_specs?: Specification[];
}
